import * as React from 'react';
export const KPSvg = React.forwardRef(function KPSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1 2h14c.555 0 1 .448 1 1v1H0V3c0-.556.448-1 1-1ZM0 12h16v1c0 .556-.448 1-1 1H1c-.555 0-1-.448-1-1v-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 4h16v8H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 12V4h1v8h-1ZM0 4h1v8H0V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
      }),
    ),
  );
});
KPSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KP = {
  category: 'flag',
  colorable: false,
  name: 'KP',
  svg: KPSvg,
};
